export default __webpack_public_path__ + "static/unlimited-accounts-any-protocol-new-3c6e9712584e7cd9fdb2a7b88c372102.webp";